import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const bossEntries: RawTilesetEntry[] = [
	{
		key: "BigContainer",
		animations: [
			{
				height: 2,
				width: 2,
				loop: true,
				frames: [{ filename: "BigBox.png", interval: 0 }],
			},
		],
	},
	{
		key: "InvulnerableBigContainer",
		animations: [
			{
				height: 2,
				width: 2,
				loop: true,
				frames: [{ filename: "BigBox.png", interval: 0 }],
			},
		],
	},
	{
		key: "BigSquidCorpse",
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: true,
				pointsTo: ["E"],
				tags: { hurt: false },
				frames: [{ filename: "BigSquidHeadCorpse.png", interval: 0 }],
			},
		],
	},
	{
		key: "BigSquidTentacleCorpse",
		sprites: ["BigSquidTentacleCorpse.png", "BigSquidTentacleCorpse2.png"],
	},
	{
		key: "BigSquid",
		allowTransform: true,
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: true,
				pointsTo: ["E"],
				tags: { hurt: false },
				frames: [
					{ filename: "BigSquidHead1.png", interval: 500 },
					{ filename: "BigSquidHead2.png", interval: 500 },
				],
			},
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: true,
				pointsTo: ["E"],
				tags: { hurt: true },
				frames: [
					{ filename: "BigSquidHeadHurt1.png", interval: 500 },
					{ filename: "BigSquidHeadHurt2.png", interval: 500 },
				],
			},
		],
	},
	{
		key: "BigSquidTentacle",
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: -1,
				frames: [
					{ filename: "BigSquidTentacleW.png", interval: 250 },
					{ filename: "BigSquidTentacleW2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["E"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: -1,
				horizontalFlip: true,
				frames: [
					{ filename: "BigSquidTentacleW.png", interval: 250 },
					{ filename: "BigSquidTentacleW2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["N"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -2,
				rotation: 1,
				frames: [
					{ filename: "BigSquidTentacleW.png", interval: 250 },
					{ filename: "BigSquidTentacleW2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["S"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: 0,
				rotation: 3,
				frames: [
					{ filename: "BigSquidTentacleW.png", interval: 250 },
					{ filename: "BigSquidTentacleW2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["SW"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: 0,
				rotation: 3,
				frames: [
					{ filename: "BigSquidTentacleNWA1.png", interval: 250 },
					{ filename: "BigSquidTentacleNWA2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["SE"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: 0,
				horizontalFlip: false,
				verticalFlip: true,
				rotation: 1,
				frames: [
					{ filename: "BigSquidTentacleNWA1.png", interval: 250 },
					{ filename: "BigSquidTentacleNWA2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: -2,
				horizontalFlip: true,
				frames: [
					{ filename: "BigSquidTentacleNWA1.png", interval: 250 },
					{ filename: "BigSquidTentacleNWA2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["NW"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleNWA1.png", interval: 250 },
					{ filename: "BigSquidTentacleNWA2.png", interval: 250 },
				],
			},
			{
				loop: true,
				pointsTo: ["S"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: 0,
				frames: [
					{ filename: "BigSquidTentacleWRetracted.png", interval: 0, rotation: 3 },
				],
			},
			{
				loop: true,
				pointsTo: ["N"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleWRetracted.png", interval: 0, rotation: 1 },
				],
			},
			{
				loop: true,
				pointsTo: ["W"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: -1,
				frames: [
					{ filename: "BigSquidTentacleWRetracted.png", interval: 0, horizontalFlip: false },
				],
			},
			{
				loop: true,
				pointsTo: ["E"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: -1,
				frames: [
					{ filename: "BigSquidTentacleWRetracted.png", interval: 0, horizontalFlip: true },
				],
			},
			{
				loop: true,
				pointsTo: ["SW"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: 0,
				frames: [
					{ filename: "BigSquidTentacleNWRetracted.png", interval: 0, rotation: 3 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleNWRetracted.png", interval: 0, rotation: 1 },
				],
			},
			{
				loop: true,
				pointsTo: ["NW"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleNWRetracted.png", interval: 0, horizontalFlip: false },
				],
			},
			{
				loop: true,
				pointsTo: ["SE"],
				tags: { extended: false },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: 0,
				frames: [
					{ filename: "BigSquidTentacleNWRetracted.png", interval: 0, rotation: 2 },
				],
			},
		],
	},
	{
		key: "BigSquidTentacleCut",
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: -1,
				frames: [
					{ filename: "BigSquidTentacleWDmg.png", interval: 0, horizontalFlip: false },
				],
			},
			{
				loop: true,
				pointsTo: ["E"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: -1,
				frames: [
					{ filename: "BigSquidTentacleWDmg.png", interval: 0, horizontalFlip: true },
				],
			},
			{
				loop: true,
				pointsTo: ["N"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleWDmg.png", interval: 0, rotation: 1 },
				],
			},
			{
				loop: true,
				pointsTo: ["S"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: 0,
				frames: [
					{ filename: "BigSquidTentacleWDmg.png", interval: 0, rotation: 3 },
				],
			},
			{
				loop: true,
				pointsTo: ["SW"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: 0,
				frames: [
					{ filename: "BigSquidTentacleNWDmg.png", interval: 0, rotation: 3 },
				],
			},
			{
				loop: true,
				pointsTo: ["SE"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: 0,
				frames: [
					{ filename: "BigSquidTentacleNWDmg.png", interval: 0, rotation: 2 },
				],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: -2,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleNWDmg.png", interval: 0, rotation: 1 },
				],
			},
			{
				loop: true,
				pointsTo: ["NW"],
				tags: { extended: true },
				height: 3,
				width: 3,
				offsetX: 0,
				offsetY: -2,
				frames: [
					{ filename: "BigSquidTentacleNWDmg.png", interval: 0, horizontalFlip: false },
				],
			},
		],
	},
];
